import { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { XCircle } from "lucide-react";
import { useStartSubscriptionView } from "@/hooks/useStartSubscriptionView";
import { Button } from "@/components/primitives/button";

/**
 * Landing page after a user abandons the Stripe checkout flow.
 * Only reachable with ?session_id=cs_xxx — otherwise redirects to root.
 * Does NOT handle portal returns (those land on / with ?portal_return=true).
 */
export default function SubscriptionCancelPage() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const startSubscriptionView = useStartSubscriptionView();

  const chatRoute = "/";
  const sessionId = searchParams.get("session_id");

  // Guard: no session_id → not a valid checkout cancel, redirect to root
  useEffect(() => {
    if (!sessionId) {
      navigate(chatRoute, { replace: true });
    }
  }, [sessionId, chatRoute, navigate]);

  const handleBackToPlans = () => {
    startSubscriptionView();
  };

  if (!sessionId) {
    return null;
  }

  return (
    <div className="flex h-screen w-full items-center justify-center bg-background text-foreground">
      <div className="flex w-full max-w-sm flex-col items-center gap-4 rounded-xl bg-card p-8 shadow-md">
        <XCircle className="size-12 text-muted-foreground" />
        <h1 className="text-xl font-semibold">
          {t("subscription.checkoutCancelled")}
        </h1>
        <p className="text-center text-sm text-muted-foreground">
          {t("subscription.checkoutCancelledDescription")}
        </p>
        <Button className="w-full" onClick={handleBackToPlans}>
          {t("subscription.backToPlans")}
        </Button>
      </div>
    </div>
  );
}
